"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSelectStyle;

var _OptComboBtnDef = _interopRequireDefault(require("./img/OptComboBtnDef.gif"));

var _OptComboBtnDown = _interopRequireDefault(require("./img/OptComboBtnDown.gif"));

var _OptComboExpand = _interopRequireDefault(require("./img/OptComboExpand.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getSelectStyle(width, height) {
  return {
    container: function container(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        width: width,
        maxWidth: "128px",
        fontSize: "12px",
        display: "inline-block"
      });
    },
    control: function control(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, {
        color: "#FFF",
        background: "none",
        boxShadow: "none",
        opacity: state.isDisabled ? 0.5 : 1,
        height: height,
        minHeight: height,
        lineHeight: height,
        border: "none",
        borderRadius: 0,
        backgroundImage: "url(".concat(_OptComboExpand.default, ")"),
        backgroundSize: "cover"
      });
    },
    valueContainer: function valueContainer(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        padding: "0 2px",
        height: height,
        minHeight: height,
        lineHeight: height
      });
    },
    singleValue: function singleValue(base, state) {
      var opacity = state.isDisabled ? 0.5 : 1;
      var transition = "opacity 300ms";
      return _objectSpread(_objectSpread({}, base), {}, {
        color: "#FFF",
        opacity: opacity,
        transition: transition
      });
    },
    input: function input(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        height: height,
        minHeight: height,
        margin: 0,
        padding: "0 2px",
        color: "#FFF"
      });
    },
    indicatorsContainer: function indicatorsContainer(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        width: height,
        height: height
      });
    },
    indicatorSeparator: function indicatorSeparator(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        display: "none"
      });
    },
    dropdownIndicator: function dropdownIndicator(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, {
        width: height,
        height: height,
        margin: 0,
        backgroundImage: state.isFocused ? "url(".concat(_OptComboBtnDown.default, ")") : "url(".concat(_OptComboBtnDef.default, ")"),
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        svg: {
          display: "none"
        }
      });
    },
    menu: function menu(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        borderRadius: 0,
        background: "rgba(0, 0, 0, 0.75)",
        hyphens: "auto",
        marginTop: 0,
        wordWrap: "break-word",
        boxShadow: "2px 2px 2px rgba(0, 0, 0, 0.4)",
        textAlign: "left"
      });
    },
    menuList: function menuList(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        padding: 0
      });
    },
    option: function option(base, state) {
      var backgroundColor = state.isSelected ? state.isFocused ? "#FFF" : "#AAA" : "";
      var color = state.isSelected ? state.isFocused ? "black" : "#333" : "#AAA";
      return _objectSpread(_objectSpread({}, base), {}, {
        padding: "2px",
        fontFamily: "Arial, Helvetica, sans-serif",
        color: color,
        backgroundColor: backgroundColor,
        "&:hover": {
          color: "#FFF",
          textShadow: "none",
          backgroundColor: "#AAA"
        }
      });
    }
  };
}